import { render, staticRenderFns } from "./OnboardingAiRequests.vue?vue&type=template&id=0ef6b640"
import script from "./OnboardingAiRequests.vue?vue&type=script&lang=js"
export * from "./OnboardingAiRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports